import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

// third party modules
import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';

// bayclubs modules

// application modules
import { SharedModule } from '@shared/shared.module';

// store
import { CourtEventNoteSaveState } from './+store/court-event-note-save.state';

// containers
import { SpinnerModule } from '@bayclubs/spinner';
import { CourtEventNoteSaveModalComponent } from './containers/court-event-note-save-modal/court-event-note-save-modal.component';

@NgModule({
    declarations: [
        CourtEventNoteSaveModalComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([CourtEventNoteSaveState]),
        NgxsFormPluginModule,
        TranslateModule,
        SharedModule,
        SpinnerModule
    ]
})
export class CourtEventNoteSaveModule { }

export { SaveCourtEventNoteSuccessAction } from './+store/court-event-note-save.actions';
export { CourtEventNoteSaveLauncherService } from './services/court-event-note-save-launcher.service';

